import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

export function initalizeToggleItemState(items) {
  const initalToggleItemState = {};
  items.forEach(item => {
    initalToggleItemState[item.label] = false;
  });
  return initalToggleItemState;
}

export function toggleAllItems(items) {
  const initalToggleItemState = {};

  Object.keys(items).forEach(key => {
    initalToggleItemState[key] = !items[key];
  });

  return initalToggleItemState;
}

function SVGIcon({ svgIcon }) {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: svgIcon,
      }}
    />
  );
}

export function setOpacityForTitle(toggleItems) {
  return Object.values(toggleItems).every(v => v) ? 0.4 : 1;
}

function Group({ group, toggleSeries }) {
  const { isToggle, title, items } = group;
  const [toggleItems, setToggleItems] = useState(initalizeToggleItemState(items));
  return (
    <div className="scattergrams-legend-group-container">
      {isToggle ? (
        <div
          className="clickable-title-container"
          role="button"
          style={{
            opacity: setOpacityForTitle(toggleItems),
          }}
          onClick={() => {
            setToggleItems(toggleAllItems(toggleItems));
            items.forEach(i => toggleSeries(i.seriesIndex));
          }}
        >
          <h4>{title}</h4>
        </div>
      ) : (
        <div
          style={{
            opacity: setOpacityForTitle(toggleItems),
          }}
        >
          <h4>
            <i>{title}</i>
          </h4>
        </div>
      )}
      {items.map(item => (
        <div
          role="button"
          className="scattergrams-legend-item"
          style={{
            opacity: toggleItems[item.label] ? '0.4' : 1,
          }}
          key={`${title}-${item.seriesIndex}`}
          onClick={() => {
            toggleSeries(item.seriesIndex);
            setToggleItems({
              ...toggleItems,
              [item.label]: !toggleItems[item.label],
            });
          }}
        >
          <SVGIcon svgIcon={item.svgIcon} />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export default Group;

Group.propTypes = {
  group: PropTypes.object,
};

SVGIcon.propTypes = {
  svgIcon: PropTypes.string,
};
